import { Component, Input } from '@angular/core';
import { DsChipColorVariant } from '@levelaccess/design-system';
import { BaseCellComponent, ICellConfig, IIconConfig, ITagConfig } from '../base-cell/base-cell.component';

export interface ITextCellConfig extends ICellConfig, ITagConfig {
  icon?: IIconConfig;
  tagLabel?: string;
  tagColorVariant?: DsChipColorVariant;
  tagTooltip?: string;
  for?: string;
}

@Component({
  selector: 'table-cell-text',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    <ng-template #icon>
      <svg
        [ngClass]="config.icon.iconBeforeText ? 'me-2' : 'ms-2'"
        [attr.aria-hidden]="!config.icon.iconAriaLabelText"
        [attr.width]="config.icon.iconWidth"
        [attr.height]="config.icon.iconHeight"
        [ngStyle]="config.icon.iconStyles"
        [attr.aria-labelledby]="!!config.icon.iconAriaLabelText ? 'iconTitle' : null"
        #svgTemplate
      >
        @if (!!config.icon.iconAriaLabelText) {
          <title id="iconTitle">
            {{ config.icon.iconAriaLabelText }}
          </title>
        }
        <use [attr.xlink:href]="'#' + config.icon.iconName"></use>
      </svg>
    </ng-template>
    @if (config.icon && config.icon.iconBeforeText) {
      <ng-template [ngTemplateOutlet]="icon"></ng-template>
    }
    @if (config.for) {
      <label #ref [ngStyle]="config?.styles" [for]="config.for" class="font-normal" [class.margin-right]="config.tagLabel">
        {{ config.text }}
      </label>
    } @else {
      <span #ref [ngStyle]="config?.styles" [class.margin-right]="config.tagLabel">{{ config.text }}</span>
    }
    @if (config.icon && !config.icon.iconBeforeText) {
      <ng-template [ngTemplateOutlet]="icon"></ng-template>
    }
    @if (config.tagLabel) {
      <ds-chip
        class="tag-label"
        data-test-id="table-cell-tag-label"
        role="button"
        [text]="config.tagLabel"
        [colorVariant]="config.tagColorVariant"
        [size]="'small'"
        [appTooltip]="config.tagTooltip"
        [attr.aria-label]="config.tagTooltip"
      ></ds-chip>
    }
    @if (config.subText) {
      <div class="sub-text" data-test-id="table-cell-sub-text">
        {{ config.subText }}
      </div>
    }
  `,
})
export class TextCellComponent extends BaseCellComponent {
  @Input() public config: ITextCellConfig;
}
